<template>
  <div class="data-table-page">
        <el-table
          :data="tableData"
          style="width: 100%">
          <el-table-column
            align="center"
            prop="time"
            label="时间">
          </el-table-column>
          <el-table-column
            align="center"
            prop="nWireTemperatuer"
            label="N相导线温度">
          </el-table-column>
          <el-table-column
            align="center"
            prop="bVoltage"
            label="B相电压">
          </el-table-column>
          <el-table-column
            align="center"
            prop="bWireTemperatuer"
            label="B相导线温度">
          </el-table-column>
          <el-table-column
            align="center"
            prop="cVoltage"
            label="C相电压">
          </el-table-column>
          <el-table-column
            align="center"
            prop="aVoltage"
            label="A相电压">
          </el-table-column>
          <el-table-column
            align="center"
            prop="aElectricCurrent"
            label="A相电流">
          </el-table-column>

          <el-table-column
            align="center"
            prop="cWireTemperatuer"
            label="C相导线温度">
          </el-table-column>
          <el-table-column
            align="center"
            prop="bElectricCurrent"
            label="B相电流">
          </el-table-column>
          <el-table-column
            align="center"
            prop="bVoltage"
            label="B相电压">
          </el-table-column>
          <el-table-column
            align="center"
            prop="cElectricCurrent"
            label="C相电流">
          </el-table-column>
          <el-table-column
            align="center"
            prop="cVoltage"
            label="C相电压">
          </el-table-column>
          <el-table-column
            align="center"
            prop="leakageCurrent"
            label="漏电流">
          </el-table-column>
          <el-table-column
            align="center"
            prop="aWireTemperatuer"
            label="C相导线温度">
          </el-table-column>
          <el-table-column
            align="center"
            prop="fileSource"
            label="文件来源">
          </el-table-column>
          <el-table-column
            align="center"
            prop="fileDigest"
            label="文件指纹">
          </el-table-column>
          <el-table-column
            align="center"
            prop="digest"
            label="数据摘要">
          </el-table-column>
          <el-table-column
            align="center"
            prop="blockTime"
            label="区块时间">
          </el-table-column>

        </el-table>

        <el-pagination
          @current-change="fetchList"
          :current-page.sync="currentPage"
          layout="prev, pager, next"
          :total="totalNum">
        </el-pagination>
      </div>

</template>

<script>

export default {
  data() {
    return {
      currentPage: 1,
      tableData: [],
      totalNum: 10
    }
  },
  components: {},
  computed: {},

  mounted() {
    this.fetchList()
  },
  methods: {
    fetchList() {
      this.$http(null, '/data/power-electricity/evidence/page', {
        cur: this.currentPage++,
        size: 10
      }, 'get').then(res => {
        this.tableData = res.records
        this.currentPage = res.current
        this.totalNum = res.total
      })
    }
  }
}
</script>

<style lang="scss" scoped>

.data-table-page::v-deep {
  padding: 20px;

  .el-table, .el-table__expanded-cell, .el-table tr, .el-table .el-table__expanded-cell, .el-table th.el-table__cell{
    background: transparent;
  }

  .el-table, .el-table thead {
    color: #fff;
  }



  .el-table__body {
    tr:hover>td{
      color: rgba(29, 35, 47, 1);
    }
  }

  .el-pagination {
    margin-top: 20px;
  }

  .el-pagination button:disabled, .el-pager li, .el-pagination .btn-next, .el-pagination .btn-prev{
    background: transparent;
    color: #fff;
  }

  .el-pager li.active {
    background: #fff;
    color: rgba(29, 35, 47, 1);
  }

}

.layout-container {
  height: 100vh;

  .el-aside {
    background-color: #232323;

    .el-menu {
      border-right: none;

    }
  }


}

</style>
